import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Box, Flex, Image, Text } from 'roo-ui/components';
import { luggage } from 'roo-ui/assets';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import TextButton from 'components/TextButton';
import { useDataLayer } from 'hooks/useDataLayer';

const InfoBox = styled(Box)`
  margin-bottom: ${themeGet('space.8')};
  border: ${themeGet('borders.2')};
  border-color: ${themeGet('colors.greys.alto')};
  padding: ${themeGet('space.4')} 0;
  color: ${themeGet('colors.greys.charcoal')};
  border-radius: ${themeGet('radii.default')};
`;

const BookingKnowBeforeYouGo = (props) => {
  const { emitInteractionEvent } = useDataLayer();

  const handleScroll = () => {
    const offsetTop = get(props, 'knowBeforeYouGoRef.current.offsetTop', 0);
    window.scrollTo(0, offsetTop);
    emitInteractionEvent({ type: 'Know Before You Go Link', value: 'Link Button' });
  };

  return (
    <InfoBox data-print-style="hidden">
      <Flex flexDirection="row" alignItems={['flex-start', 'center']} justifyContent={['flex-start', 'center']} px={2}>
        <Flex justifyContent="center" minWidth={[48, 32]}>
          <Image m={0} pt={[2, 0]} px={[2, 0]} width="100%" height="auto" src={luggage} alt="luggage icon" />
        </Flex>
        <Box ml={[0, 4]} textAlign={['start', 'center']} data-testid="know-before-you-go-text">
          <Text display="inline" fontSize={['sm', 'base']} fontWeight="bold">
            Please note,{' '}
          </Text>
          <Text display="inline" fontSize={['sm', 'base']}>
            there is important information about your stay to{' '}
          </Text>
          <TextButton
            color="greys.charcoal"
            onClick={handleScroll}
            fontSize={['sm', 'base']}
            data-testid="booking-modal-button"
            aria-label="Important information about your stay"
          >
            know before you go.
          </TextButton>
        </Box>
      </Flex>
    </InfoBox>
  );
};

BookingKnowBeforeYouGo.propTypes = {
  knowBeforeYouGoRef: PropTypes.shape({
    current: PropTypes.shape({
      offsetTop: PropTypes.number,
    }),
  }),
};

BookingKnowBeforeYouGo.defaultProps = {
  knowBeforeYouGoRef: {},
};

BookingKnowBeforeYouGo.displayName = 'BookingKnowBeforeYouGo';

export default BookingKnowBeforeYouGo;
